export default __webpack_public_path__ + "static/zine-303234960f746a6c440af1e4d83ca4db.svg";